import { POS_Agent, POS_Config, POS_Transactions } from "./api";

const posTransactionApi = new POS_Transactions();
const posConfigApi = new POS_Config();
const posAgentApi = new POS_Agent();

export { posTransactionApi, posConfigApi, posAgentApi };
